import {Injectable} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {PopupSnackbarComponent} from "./popup-snackbar.component";
import {TariffInfoRecord} from "../../emp/cdrlifecycle/tariff/emp-tariff/emp-tariff.component";

@Injectable({
    providedIn: 'root',
})
export class SnackBarService {

    constructor(private _snackBar: MatSnackBar) {
    }

    showErrorSnackBar(message: string) {

        this._snackBar.openFromComponent(PopupSnackbarComponent, {

            verticalPosition: 'top',
            horizontalPosition: 'center',
            data: {message, type: 'error'},
            duration: 5000,
        });
    }

    showInfoSnackBar(message: string) {

        this._snackBar.openFromComponent(PopupSnackbarComponent, {

            verticalPosition: 'top',
            horizontalPosition: 'center',
            data: {message, type: 'info'},
            duration: 5000,
        });
    }

    showLinkSnackBar(message: string, tariff: TariffInfoRecord) {

        this._snackBar.openFromComponent(PopupSnackbarComponent, {

            verticalPosition: 'top',
            horizontalPosition: 'center',
            data: {
                message, tariff: tariff, type: 'link', preClose: () => {
                    this._snackBar.dismiss()
                }
            },
            duration: 0,

        });
    }
}

export interface PopupSnackBarConfig {
    message: string;
    tariff: string;
    type: 'info' | 'link' | 'error';
    preClose: any;
}

